import { createSelector } from "reselect";
import type { RootState } from "typesafe-actions";
import type { UserState } from "./user.reducer";

export const user = (state: RootState): UserState => state.context.user;

export const userId = (state: RootState): string => user(state).profile.userId;

export const selectUserIsLoggedIn = createSelector(
  [user],
  (userState) => userState.isLoggedIn === true,
);

export const selectUserOrgBannerUrl = createSelector(
  [user],
  (userState) => userState.orgBannerUrl,
);

export const selectUserProfile = createSelector([user], (user) => user.profile);

export const selectUserProfileEmail = createSelector(
  [selectUserProfile],
  (userProfile) => userProfile.email,
);

export const isPasswordRequired = (state: RootState): boolean =>
  user(state).requiresPassword;

export const workspacesPrivateByDefault = (state: RootState): boolean =>
  !!user(state).policies?.workspacesPrivateByDefault;

export const authorizationHeader = createSelector([user], (user) => ({
  Authorization: `Bearer ${user.token}`,
}));

export const userToken = (state: RootState): string => user(state).token;

export const selectUserToken = createSelector(
  [user],
  (userState) => userState.token,
);

export const getUserOrgId = createSelector(
  [user],
  (userState) => userState.profile.orgId,
);

export const selectUserMarbleColor = createSelector(
  [user],
  (userState) => userState.userMarbleColor,
);

export const selectUserName = createSelector(
  [user],
  (userState) => userState.profile.firstName,
);
